export default __webpack_public_path__ + "static/media/text-input-info.c2e88af9.svg";